import { MODULES } from "../shared/constants/modules";

const ROTAS_POR_MODULO = [
	{ prefixos: ["/web-ordering", "/order", "/confirmed"], modulo: MODULES.PEDIDOS },
	{ prefixos: ["/gerar-cupons"], modulo: MODULES.GERAR_CUPONS },
	{ prefixos: ["/marketingcenter"], modulo: MODULES.MARKETING_CENTER },
	{ prefixos: ["/atacado-labs", "/atacado", "/confirmed-atacado"], modulo: MODULES.ATACADO },
	{ prefixos: ["/lente-pronta-pedido", "/lente-pronta", "/confirmed-lente-pronta"], modulo: MODULES.LENTE_PRONTA },
];

export const MODULOS_COM_CHAT_FLUTUANTE = [
	MODULES.PEDIDOS,
	MODULES.GERAR_CUPONS,
	MODULES.MARKETING_CENTER,
	MODULES.ATACADO,
	MODULES.LENTE_PRONTA,
];

export function acessoLiberado(contexto) {
	return !contexto || contexto.habilitado !== false;
}

export function modulosDoFlutuante(contexto) {
	return contexto && Array.isArray(contexto.modulosFlutuante)
		? contexto.modulosFlutuante
		: MODULOS_COM_CHAT_FLUTUANTE;
}

export function moduleForPath(pathname) {
	if (!pathname) return null;
	const encontrado = ROTAS_POR_MODULO.find(entrada =>
		entrada.prefixos.some(prefixo => pathname === prefixo || pathname.startsWith(prefixo + "/"))
	);
	return encontrado ? encontrado.modulo : null;
}

export function moduleForLocation(location, moduloAnterior) {
	const pathname = (location && location.pathname) || "";
	const modulo = moduleForPath(pathname);
	if (modulo !== MODULES.PEDIDOS) return modulo;

	const promocional = !!(location.state && location.state.isPedidoPromocional);
	const seguePromocional = moduloAnterior === MODULES.GERAR_CUPONS && !pathname.startsWith("/web-ordering");
	return promocional || seguePromocional ? MODULES.GERAR_CUPONS : modulo;
}

function decodeTokenPayload() {
	const token = sessionStorage.getItem("token");
	if (!token) return null;
	const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
	const json = decodeURIComponent(
		atob(base64)
			.split("")
			.map(char => "%" + ("00" + char.charCodeAt(0).toString(16)).slice(-2))
			.join("")
	);
	return JSON.parse(json);
}

export function getJti() {
	try {
		const payload = decodeTokenPayload();
		return (payload && payload.jti) || null;
	} catch (e) {
		return null;
	}
}

const COUNTER_PREFIX = "repondeur.";

export function jaAquecido(jti) {
	if (!jti) return true;
	return localStorage.getItem(COUNTER_PREFIX + jti + ".warm") === "1";
}

export function marcarAquecido(jti) {
	if (!jti) return;
	localStorage.setItem(COUNTER_PREFIX + jti + ".warm", "1");
}

export const WARM_UP_MESSAGE = "Olá";

export const isCoarsePointer = () =>
	typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches;

export function readCounter(jti) {
	if (!jti) return 0;
	const value = parseInt(localStorage.getItem(COUNTER_PREFIX + jti + ".message"), 10);
	return isNaN(value) ? 0 : value;
}

export function saveCounter(jti, value) {
	if (!jti) return;
	Object.keys(localStorage)
		.filter(key => key.startsWith(COUNTER_PREFIX) && key.indexOf(COUNTER_PREFIX + jti + ".") !== 0)
		.forEach(key => localStorage.removeItem(key));
	localStorage.setItem(COUNTER_PREFIX + jti + ".message", String(value));
}

export function parseSseEvents(buffer) {
	const events = [];
	let rest = buffer;
	let separator = rest.indexOf("\n\n");

	while (separator !== -1) {
		const rawEvent = rest.slice(0, separator);
		rest = rest.slice(separator + 2);

		const data = rawEvent
			.split("\n")
			.filter(line => line.startsWith("data:"))
			.map(line => line.slice(5).trim())
			.join("\n");

		const eventName = rawEvent
			.split("\n")
			.filter(line => line.startsWith("event:"))
			.map(line => line.slice(6).trim())[0];

		if (data) {
			events.push({ event: eventName || "message", data });
		}
		separator = rest.indexOf("\n\n");
	}

	return { events, rest };
}

const TEXT_FIELDS = ["content", "text", "delta", "answer", "message", "response"];

export function extractChunkText(data) {
	if (!data || data === "[DONE]") return null;
	try {
		const parsed = JSON.parse(data);
		if (typeof parsed === "string") return parsed;
		if (parsed.answer && typeof parsed.answer.text === "string") return parsed.answer.text;
		for (const field of TEXT_FIELDS) {
			if (typeof parsed[field] === "string") return parsed[field];
		}
		return null;
	} catch (e) {
		return data;
	}
}

const INDISPONIVEL = "Não é possível atender à requisição no momento. Tente novamente mais tarde.";

export const ERROR_MESSAGES = {
	403: "Seu papel ainda não está configurado para usar o Conecta Responde.",
	422: "Mensagem não autorizada pela moderação.",
	429: "Esta conversa atingiu o limite permitido. Faça logout e login novamente para iniciar uma nova conversa.",
	500: INDISPONIVEL,
	502: INDISPONIVEL,
	503: INDISPONIVEL,
};

export function errorMessageForStatus(status) {
	return ERROR_MESSAGES[status] || INDISPONIVEL;
}

export function saudacaoPorHora(hora) {
	if (hora >= 5 && hora < 12) return "Bom dia";
	if (hora >= 12 && hora < 18) return "Boa tarde";
	return "Boa noite";
}

export function getNomeUsuario() {
	try {
		const payload = decodeTokenPayload();
		return (payload && payload.usuario && payload.usuario.nome) || "";
	} catch (e) {
		return "";
	}
}

export function getNomeCompletoUsuario() {
	try {
		const payload = decodeTokenPayload();
		const usuario = (payload && payload.usuario) || {};
		return [usuario.nome, usuario.sobrenome].filter(Boolean).join(" ");
	} catch (e) {
		return "";
	}
}

export function getIniciaisUsuario() {
	const nome = getNomeCompletoUsuario();
	if (!nome) return "";
	const partes = nome.trim().split(/\s+/);
	const primeira = partes[0].charAt(0);
	const ultima = partes.length > 1 ? partes[partes.length - 1].charAt(0) : "";
	return (primeira + ultima).toUpperCase();
}

// recorta o próximo pedaço a revelar: espaços à frente, a palavra e o espaço
// seguinte, para que a concatenação reproduza o texto original
export function proximaPalavra(texto) {
	const encontrado = texto.match(/^\s*\S+\s*/);
	return encontrado ? encontrado[0] : texto;
}

export function formatTime(date) {
	if (!date) return "";
	const d = new Date(date);
	return String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
}

// lê as cores diretamente do arquivo da marca, para a animação acompanhar
// qualquer troca de logo sem alteração de código
export function extrairCoresDaMarca(svgTexto) {
	const encontradas = svgTexto.match(/#[0-9a-fA-F]{6}/g) || [];
	const vistas = [];

	encontradas.forEach(cor => {
		const hex = cor.toLowerCase();
		if (vistas.indexOf(hex) !== -1) return;

		const r = parseInt(hex.slice(1, 3), 16) / 255;
		const g = parseInt(hex.slice(3, 5), 16) / 255;
		const b = parseInt(hex.slice(5, 7), 16) / 255;
		const maior = Math.max(r, g, b);
		const menor = Math.min(r, g, b);
		const luz = (maior + menor) / 2;
		const saturacao = maior === menor ? 0 : (maior - menor) / (1 - Math.abs(2 * luz - 1));

		if (saturacao > 0.3 && luz > 0.2 && luz < 0.85) {
			vistas.push(hex);
		}
	});

	return vistas;
}
